<div class="image-wrapper">
  <div *ngIf="isRotationAllowed" class="image-rotation-button-wrapper">
    <div>
      <button mat-icon-button (click)="rotateImage(-90)">
        <ui-svg-icon [name]="iconNames.Undo"></ui-svg-icon>
      </button>
      <button mat-icon-button (click)="rotateImage(90)">
        <ui-svg-icon [name]="iconNames.Redo"></ui-svg-icon>
      </button>
    </div>
    <div>
      <ui-action-button
        [action]="buttonAction.Save"
        [type]="buttonType.Primary"
        (buttonClick)="saveImageRotation()"
      ></ui-action-button>
    </div>
  </div>

  <hr class="divider--vertical" />

  <div class="image-wrapper__image">
    <img #image class="image" [src]="imageSrc" alt="attachment" />
  </div>
  <ng-container *ngIf="(imageList | async)?.length > 1">
    <div class="arrow__item arrow__item_prev pointer" (click)="prev(decrement)" (keydown.ArrowLeft)="prevAttach()">
      <i class="arrow__item_left"></i>
    </div>
  </ng-container>

  <ng-container *ngIf="(imageList | async)?.length > 1">
    <div class="arrow__item arrow__item_next pointer" (click)="next(increment)" (keydown.ArrowRight)="nextAttach()">
      <i class="arrow__item_right"></i>
    </div>
  </ng-container>
</div>
